import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '类型',
      placeholder: '请选择类型',
      options: [
        { title: '不限', value: 0 },
        { title: '图片', value: 2 },
        { title: '视频号', value: 3 },
        { title: '文字', value: 4 },
        { title: '图文', value: 5 }
      ],
      clearable: true
    },
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题',
      clearable: true
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '创建日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
